import React from "react";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import ButtonGroup from "@mui/material/ButtonGroup";
import CircularProgress from "@mui/material/CircularProgress";
import { Close, Delete } from "@mui/icons-material";
import { useMutation } from "@apollo/client";
import { ELIMINAR_CONTACTOS } from "../graphql/mutations";
import { MainContext } from "../../../../../Context/MainCtx";
import { ContactosContext } from "../Context/ContactoContext";
import { isMobile } from "../../../../../Config/constantes";

export default function DeleteManyContacto() {
  const [loading, setLoading] = React.useState(false);
  const { snackMessage } = React.useContext(MainContext);
  const {
    queryRefetch,
    isSelecting,
    setIsSelecting,
    itemsSelected,
    setItemsSelected,
    setIndeterminated,
  } = React.useContext(ContactosContext);
  const [eliminarContactos] = useMutation(ELIMINAR_CONTACTOS);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-delete-contacto" : undefined;

  const handleRemove = () => {
    setItemsSelected([]);
    setIndeterminated(false);
    setIsSelecting(false);
  };

  const handleDeleteContactos = async () => {
    try {
      if (!itemsSelected.length) return;
      const contactosToDelete = itemsSelected.map(({ _id }) => _id);
      handleClose();
      setLoading(true);
      await eliminarContactos({
        variables: {
          contactosToDelete,
        },
      });
      queryRefetch();
      setLoading(false);
      handleRemove();
    } catch (err) {
      setLoading(false);
      console.log(err.networkError?.result);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        color="warning"
        size="small"
        disableElevation
      >
        <Button
          color="warning"
          size="small"
          variant="contained"
          disabled={!itemsSelected.length}
          startIcon={
            isMobile ? null : loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              <Delete />
            )
          }
          disableElevation
          form="form-contacto-table"
          type="submit"
          sx={{ textTransform: "none", minWidth: 40 }}
          onClick={handleClick}
        >
          {isMobile ? (
            loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              <Delete fontSize="small" />
            )
          ) : (
            "Eliminar"
          )}
        </Button>
        {isSelecting ? (
          <Button
            hidden={isSelecting}
            size="small"
            onClick={handleRemove}
            sx={{ minWidth: "35px!important", padding: 0 }}
          >
            <Close sx={{ fontSize: 16 }} />
          </Button>
        ) : null}
      </ButtonGroup>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
            },
          },
        }}
      >
        <Typography>¿Continuar con la acción?</Typography>
        <Button
          sx={{ textTransform: "none" }}
          color="error"
          size="small"
          onClick={handleDeleteContactos}
          variant="contained"
          fullWidth
          disableElevation
        >
          Si, eliminar
        </Button>
      </Popover>
    </>
  );
}
